import React from "react";
import { useSelector } from "react-redux";

export default function CategoryDisplay({ page, pageSub, value }) {
  const categoryStore = useSelector((state) => state[page][`${pageSub}Categories`]);
  const category = categoryStore.list.find((category) => category["_id"] === value);
  return <span className="data-container">{category ? category.categoryName : ""}</span>;
}
